import { BoosterPackType, BoosterPacks } from "./UserActionsView.types";

interface BoosterPackSectionProps {
    loading: boolean;
    boosterPacks: BoosterPacks;
    selectedBooster: BoosterPackType;
    setSelectedBooster: (type: BoosterPackType) => void;
    applyBoosterPack: () => void;
    applying: boolean;
}

export function BoosterPackSection({
    loading,
    boosterPacks,
    selectedBooster,
    setSelectedBooster,
    applyBoosterPack,
    applying,
}: BoosterPackSectionProps) {
    if (loading) {
        return (
            <div className="bg-slate-900 border border-slate-800 rounded-xl p-5">
                <h3 className="text-lg font-bold text-white mb-4 flex items-center gap-2">
                    <span>🚀</span> Apply Booster Pack
                </h3>
                <div className="text-slate-500">Loading booster pack configuration...</div>
            </div>
        );
    }

    const selectedPack = boosterPacks[selectedBooster];

    return (
        <div className="bg-slate-900 border border-slate-800 rounded-xl p-5">
            <h3 className="text-lg font-bold text-white mb-4 flex items-center gap-2">
                <span>🚀</span> Apply Booster Pack
            </h3>

            <div className="space-y-4">
                <div className="flex flex-wrap gap-2">
                    {(Object.keys(boosterPacks) as BoosterPackType[]).map((packType) => {
                        const pack = boosterPacks[packType];
                        if (!pack.enabled) return null;
                        return (
                            <button
                                key={packType}
                                onClick={() => setSelectedBooster(packType)}
                                className={`px-4 py-2 rounded-lg font-medium transition-all ${selectedBooster === packType
                                    ? "bg-blue-600 text-white"
                                    : "bg-slate-800 text-slate-300 hover:bg-slate-700"
                                    }`}
                            >
                                {packType.replace(/_/g, " ")}
                            </button>
                        );
                    })}
                </div>

                <div className="bg-slate-800/50 rounded-lg p-4 border border-slate-700">
                    <div className="text-sm text-slate-400 mb-2">This will add:</div>
                    <div className="flex flex-wrap gap-4">
                        {selectedBooster === "weekly_pass" ? (
                            <>
                                <div className="text-white">
                                    <span className="text-2xl font-bold">{selectedPack.duration_days || 7}</span>
                                    <span className="text-slate-400 ml-1">days</span>
                                </div>
                                <div className="text-white">
                                    <span className="text-2xl font-bold">{selectedPack.voice_credits}</span>
                                    <span className="text-slate-400 ml-1">voice credits</span>
                                </div>
                            </>
                        ) : (
                            <>
                                {selectedPack.text_credits && (
                                    <div className="text-white">
                                        <span className="text-2xl font-bold text-green-400">+{selectedPack.text_credits}</span>
                                        <span className="text-slate-400 ml-1">text credits</span>
                                    </div>
                                )}
                                <div className="text-white">
                                    <span className="text-2xl font-bold text-green-400">+{selectedPack.voice_credits}</span>
                                    <span className="text-slate-400 ml-1">voice credits</span>
                                </div>
                            </>
                        )}
                    </div>
                </div>

                <button
                    onClick={applyBoosterPack}
                    disabled={applying}
                    className="px-6 py-3 bg-blue-600 hover:bg-blue-700 disabled:bg-blue-800 disabled:cursor-not-allowed text-white font-bold rounded-lg transition-all"
                >
                    {applying ? "Applying..." : `Apply ${selectedBooster.replace(/_/g, " ")}`}
                </button>
            </div>
        </div>
    );
}
